import { type ChangeEvent, useCallback, useEffect, useState } from 'react'

import { useUnit } from 'effector-react'

import CloseIcon from '@/assets/icons/icon-close.svg'
import SearchIcon from '@/assets/icons/icon-search.svg'
import { TextField } from '@/components/ui/text-field.tsx'
import {
  $mediaQueryParam,
  setMediaQuery,
} from '@/models/vault/medias/options.ts'
import { classNames } from '@/utils/helpers.ts'

interface Props {
  className?: string
}

export const VaultMediaSearchBox = ({ className }: Props) => {
  const mediaQueryParam = useUnit($mediaQueryParam)

  const [query, setQuery] = useState('')
  const resetQuery = useCallback(() => {
    setQuery('')
  }, [])

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value)
  }, [])

  useEffect(() => {
    setMediaQuery(query)
  }, [query])

  useEffect(() => {
    setQuery(mediaQueryParam)
  }, [mediaQueryParam])

  return (
    <TextField
      suffix={
        query ? (
          <CloseIcon
            onClick={resetQuery}
            className="h-4 w-4 cursor-pointer hover:opacity-70"
          />
        ) : null
      }
      prefix={<SearchIcon />}
      height={16}
      className={classNames('py-1', className)}
      placeholder="Search Vault"
      value={query}
      onChange={handleChange}
    />
  )
}
